<div class="">
  <div class="nav-container-1">
    <div class="row">
      <div class="col-xl-10 col-lg-10 col-md-8 col-sm-12 tab-container">
        <mat-tab-group (selectedTabChange)="onTabClick($event)">
          <mat-tab label="All">
            <ng-template mat-tab-label id="lblChallanList">
              All <span>{{ReviewList.length}}</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Approval">
            <ng-template mat-tab-label id="lblChallanList">
              Approval <span>{{app_ReviewList.length}}</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Invitation">
            <ng-template mat-tab-label id="lblChallanList">
              Invitation <span>{{invitation_ReviewList.length}}</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Status">
            <ng-template mat-tab-label id="lblChallanList">
              Status Update <span>{{status_ReviewList.length}}</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Comments">
            <ng-template mat-tab-label id="lblChallanList">
              Comments <span>{{comments_ReviewList.length}}</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Response">
            <ng-template mat-tab-label id="lblChallanList">
              Response <span>{{responce_ReviewList.length}}</span>
            </ng-template>
          </mat-tab>
          <!-- <mat-tab label="Impacts">
            <ng-template mat-tab-label id="lblChallanList">
              Pending For Impacts Update <span>{{impacts_ReviewList.length}}</span>
            </ng-template>
          </mat-tab> -->
        </mat-tab-group>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-xs-6  col-6 icons-container">
        <div class="d-flex justify-content-end">
          <div class="d-none d-md-block">
            <!-- <i class="fa fa-search" title="Search" aria-hidden="true" id="ibtSearch" aria-hidden="true"
              label="Advance Search"></i> -->
              <button type="button" class="btn btn-primary"
                      style="background: #1579ab;border-radius: 5px;min-width: 40px !important;height:28px;font-size: 12px !important;" *ngIf="createicon" (click)="createpeer()">Create</button>
            <!-- <i class="fa fa-plus-circle" aria-hidden="true" title="Create" *ngIf="createicon" (click)="createpeer()"></i> -->
            <i class="fa fa-question-circle" aria-hidden="true" title="Help Manual" (click)="HelpUrlClick()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="outlet_container">
    <div class="row m-0">
      <div class="col-12 p-0">
        <div  *ngIf="tabname=='All'">
          <kendo-grid [kendoGridBinding]="ReviewList" [sortable]="true" [resizable]="true" [filterable]="enableFilter"
            [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMOrgList">
            <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
            </ng-template>
            <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex justify-content-end">
                <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                  </kendo-pager-page-sizes>
                  <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
                </div>
                <div class="icons-container">
                  <div class="icon-wrap">
                    <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10"
                      style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">Export to
                      Excel</button>
                  </div>
                  <div class="d-none d-md-flex align-items-md-center">
                    <div class="icon-wrap">
                      <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                      <span class="list-icon-name">Filter</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>

            <kendo-grid-column title="Req No." field="old_Ref_Id" width="200">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="eip-link" (click)="viewPeerdoc(dataItem)">
                  {{dataItem.old_Ref_Id}}
                </span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="old_Ref_Id"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <!-- <kendo-grid-column title="Old Ref No." field="old_Ref_Id" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  {{dataItem.old_Ref_Id}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="old_Ref_Id"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column> -->

            <kendo-grid-column title="Peer Review Type" field="peer_review_type" width="180">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                {{dataItem.peer_review_type}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="peer_review_type"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <!-- <kendo-grid-column title="Scope Of Review" field="scope_of_review" width="150">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.scope_of_review}}" eipTooltipPosition="auto">
                  {{dataItem.scope_of_review}}                
                </span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="scope_of_review"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column> -->

            <kendo-grid-column title="Service Included" field="discipline" width="150">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
                  {{dataItem.discipline}}                
                </span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="discipline"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Status" field="request_Status" width="170">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.request_Status}}" eipTooltipPosition="auto">
                  {{dataItem.request_Status}}                
                </span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="request_Status"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Scheduled date" field="date" width="120">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                {{dataItem.date | date:'dd-MMM-yyyy'}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-datepicker-filter [filter]="filter" field="date"></app-datepicker-filter>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Scheduled Session" field="time_From" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                {{dataItem | sessionpipe}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="time_From"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <!-- <kendo-grid-column title="Scheduled To" field="time_To" width="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                {{dataItem.time_To}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="time_To"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column> -->

            <kendo-grid-column title="Request Created by" field="created_By" width="180">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">
                  {{dataItem.created_By}}                
                </span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="created_By"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Created on" field="created_On" width="120">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                {{dataItem.created_On | date:'dd-MMM-yyyy'}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-datepicker-filter [filter]="filter" field="created_On"></app-datepicker-filter>
              </ng-template>
            </kendo-grid-column> 
            
            <kendo-grid-column title="Approved by" field="approved_by" width="180">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.approved_by}}" eipTooltipPosition="auto">
                  {{dataItem.approved_by}}                
                </span>
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="ReviewList" Field="approved_by"></app-dropdown-filter>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Approved on" field="approved_on" width="120">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                {{dataItem.approved_on | date:'dd-MMM-yyyy'}}
              </ng-template>
              <ng-template kendoGridFilterCellTemplate let-filter>
                <app-datepicker-filter [filter]="filter" field="approved_on"></app-datepicker-filter>
              </ng-template>
            </kendo-grid-column> 

            <kendo-grid-excel fileName="ReviewList.xlsx" [fetchData]="allData"></kendo-grid-excel>
          </kendo-grid>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="tabname=='Status' || tabname=='Comments' || tabname=='Response' || tabname=='Impacts' ">
    <app-review-status [Data]="Data" (ReviewListEmitter)="OnEmit($event)"></app-review-status>
  </div>
  <div *ngIf="tabname=='Approval' || tabname=='Invitation'">
    <app-review-approval [Data]="Data" (ReviewListEmitter)="OnEmit($event)" ></app-review-approval>
  </div>

</div> 